"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dictionary = require("@otpusk/json-api/dist/dictionary");
var _CompactCardView = _interopRequireDefault(require("../../../CompactCardView"));
var _markerIcon = _interopRequireDefault(require("./markerIcon.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var Hotel = function Hotel(_ref) {
  var active = _ref.active,
    deleting = _ref.deleting,
    disabled = _ref.disabled,
    cityName = _ref.cityName,
    className = _ref.className,
    image = _ref.image,
    name = _ref.name,
    stars = _ref.stars,
    onClick = _ref.onClick,
    onDeleteButtonClick = _ref.onDeleteButtonClick;
  return /*#__PURE__*/_react.default.createElement(_CompactCardView.default, {
    active: active,
    className: className,
    disabled: disabled,
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Image, {
    src: (0, _dictionary.getImageUrl)(image, 'small')
  }), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Body, {
    description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: _markerIcon.default
      }
    }), cityName),
    title: "".concat(name, " ").concat(stars, "*")
  }), /*#__PURE__*/_react.default.createElement(_CompactCardView.default.Buttons, {
    deleting: deleting,
    onDeleteButtonClick: onDeleteButtonClick
  }));
};
Hotel.propTypes = {
  cityName: _propTypes.default.string.isRequired,
  image: _propTypes.default.string.isRequired,
  name: _propTypes.default.string.isRequired,
  stars: _propTypes.default.node.isRequired,
  active: _propTypes.default.bool,
  deleting: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onClonDeleteButtonClickick: _propTypes.default.func
};
var _default = exports.default = Hotel;